export const MASK_CHAR = "_";
